<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar">
  <!-- BEGIN scrollbar -->
  <div class="app-sidebar-content" data-scrollbar="true" data-height="100%">
    <!-- BEGIN mobile-toggler -->
    <div class="mobile-toggler">
      <button type="button" (click)="app.menuOpen = !app.menuOpen" class="menu-close btn btn-outline-primary"
        data-bs-toggle="app-sidebar-mobile-toggled" data-bs-target=".indicium-cloud">
        <i class="bi bi-arrow-left"></i>
      </button>
    </div>
    <!-- END mobile-toggler -->

    <!-- BEGIN Incident menu -->
    <div class="menu margin" *ngIf="view.startsWith('incident')">
      <div class="menu-item">
        <div [routerLink]="'/home'" class="p-3 d-flex align-items-center">
          <a class="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill"><i
              class="fa fa-arrow-left me-1 ms-n1"></i> Back</a>
        </div>
      </div>
      <div class="menu-item bg-emphasis bg-opacity-25">
        <div class="list-group mb-3">
          <div [routerLink]="'/fire-foresight/cameras'" class="list-group-item d-flex align-items-center bg-opacity-25" style="cursor:pointer;">
            <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-blue text rounded-2 ms-n1">
              <i class="bi bi-camera"></i>
            </div>
            <div class="flex-fill px-3">
              Cameras
            </div>
          </div>
        </div>    
      </div>
      <div class="menu-item bg-emphasis bg-opacity-25">
        <div class="list-group mb-3">
          <div class="input-group">
            <select class="form-select" [(ngModel)]="siteIdFilter">
              <option [value]="0">Show All</option>
              <option *ngFor="let camera of fire.cameras" [value]="camera.siteId">{{camera.name | slice:0:22}}</option>
            </select>
            <div class="input-group-text button" (click)="fire.get(false)">
              <i *ngIf="!fire.incidentsLoadStarted" class="fa fa-refresh"></i>
              <div class="spinner-border spinner-border-sm text-primary" role="status" *ngIf="fire.incidentsLoadStarted"><span class="visually-hidden">Loading...</span></div>
            </div>
          </div>
          
          
        </div>
      </div>
      
      <!-- Show message if no active detections -->
      <div *ngIf="!hasAnyActiveDetections()" class="menu-item bg-emphasis bg-opacity-25">
        <div class="list-group mb-3">
          <div class="list-group-item d-flex align-items-center justify-content-center bg-opacity-25 text-center py-4">
            <div class="text-inverse text-opacity-50">
              <i class="fa fa-inbox fa-2x mb-2"></i>
              <div>No Active Incidents</div>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngFor="let status of fire.statusTypes">    
        <ng-container *ngIf="status.visible && hasIncidentsForStatus(status.statusId)">     
        <div class="menu-header">{{status.displayName}}</div>
        <div class="menu-item bg-emphasis bg-opacity-25">
          <div class="list-group mb-3">
            
            <div [routerLink]="'/fire-foresight/incident/' + incident.incidentId" class="list-group-item d-flex align-items-center bg-opacity-25" 
              [ngClass]="{'bg-white':fire.incident && incident.incidentId == fire.incident.incidentId}" style="cursor:pointer;"
              *ngFor="let incident of fire.incidents | incidentpipe:status.statusId:siteIdFilter" (click)="toggleSidebar()">
              <div class="w-40px h-40px d-flex align-items-center justify-content-center text rounded-2 ms-n1"
                   [ngClass]="{'bg-gradient-red': isUnconfirmedIncident(incident), 'bg-gradient-orange': !isUnconfirmedIncident(incident)}">
                <i class="" [ngClass]="
                  {
                    'bi bi-camera': incident.detectionType?.displayName == 'Robotic Cats - AI', 
                    'bi bi-camera-fill': incident.detectionType?.displayName == 'Fire Foresight - AI', 
                    'fa fa-signal': incident.detectionType?.displayName == 'Sensor', 
                    'fa fa-bolt': incident.detectionType?.displayName == 'Lightning',
                    'fa fa-satellite': incident.detectionType?.displayName == 'Satellite',
                    'bi bi-person-bounding-box': incident.detectionType?.displayName == 'Manual Detection'
                  }"  
                  style="color: {{getBackgroundColour(incident)}};"></i>
              </div>
              <div class="flex-fill px-3">
                <div class="fw-bold menu-button-content">
                  <span class="small text-inverse text-opacity-50 text-nowrap text-truncate">#{{incident.incidentId}} {{incident.detectionType?.displayName}}</span>
                </div>
                <div class="text-nowrap text-truncate">{{incident.site.name | slice:0:15}}</div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="small text-inverse text-opacity-50">{{incident.fireIncidentDate | relativeDate}}</span>
                  <span class="text-opacity-80" [ngClass]="{'text-danger':incident.confidence > 50}">{{incident.confidence}}%</span>
                </div>
              </div>
            </div>

            <div class="no-items list-group-item d-flex align-items-center bg-opacity-50 text-opacity-50">
              No Incidents
            </div>

          </div>          
        </div>
        </ng-container>
      </div>
    </div>
    <!-- END Incident menu -->
    <!-- BEGIN Camera menu -->
    <div class="menu margin" *ngIf="view.startsWith('camera') || view.startsWith('landscape')">
      <div class="menu-item">
        <div [routerLink]="'/home'" class="p-3 d-flex align-items-center" (click)="app.menuOpen = !app.menuOpen">
          <a class="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill"><i
              class="fa fa-arrow-left me-1 ms-n1"></i> Back</a>
        </div>
      </div>
      <div class="menu-item bg-emphasis bg-opacity-25">
        <div class="list-group mb-3">
          <div [routerLink]="'/fire-foresight/incidents'" class="list-group-item d-flex align-items-center bg-opacity-25" 
            style="cursor:pointer;">
            <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-blue text rounded-2 ms-n1">
              <i class="bi bi-fire"></i>
            </div>
            <div class="flex-fill px-3">
              Incidents
            </div>
          </div>
        </div>          
      </div>
      <div>
        <div class="menu-header">Cameras
          <i *ngIf="!fire.cameraLoadStarted" style="cursor: pointer;" (click)="fire.getCameras()" class="fa fa-refresh"></i>
          <div class="spinner-border spinner-border-sm text-primary"  role="status" *ngIf="fire.cameraLoadStarted"><span class="visually-hidden">Loading...</span></div>
        </div>
        <div class="menu-item bg-emphasis bg-opacity-25" >
          <div class="list-group mb-3" >
            <div *ngFor="let camera of fire.cameras" [routerLink]="'/fire-foresight/camera/' + camera.siteId" class="list-group-item d-flex align-items-center bg-opacity-25"
              [ngClass]="{'bg-white':camera.siteId == siteId}" style="cursor:pointer;" (click)="toggleSidebar()">
              <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-orange text rounded-2 ms-n1"
                [ngClass]="{'bg-gradient-green':!camera.offline,'bg-gradient-red':camera.offline}">
                <i class="bi bi-camera"></i>
              </div>
              <div class="flex-fill px-3">
                <div class="fw-bold"><span class="small text-inverse text-opacity-50"></span> {{camera.name | slice:0:22}}</div>
                <div class="flex-fill">
                  <div class="text-inverse text-opacity-50">{{camera.twin?.latestTimeStamp | relativeDate}}</div>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
    <!-- END Cameramenu -->
    <!-- BEGIN Planned Burns menu -->
    <div class="menu margin" *ngIf="view.startsWith('planned-burn') || view.startsWith('burn-list')">
      <div class="menu-item">
        <div [routerLink]="'/home'" class="p-3 d-flex align-items-center" (click)="app.menuOpen = !app.menuOpen">
          <a class="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill"><i
              class="fa fa-arrow-left me-1 ms-n1"></i> Back</a>
        </div>
      </div>
      <div class="menu-item bg-emphasis bg-opacity-25">
        <div class="list-group mb-3">
          <div [routerLink]="'/fire-foresight/incidents'" class="list-group-item d-flex align-items-center bg-opacity-25" 
            style="cursor:pointer;">
            <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-blue text rounded-2 ms-n1">
              <i class="bi bi-fire"></i>
            </div>
            <div class="flex-fill px-3">
              Incidents
            </div>
          </div>
          <div [routerLink]="'/fire-foresight/cameras'" class="list-group-item d-flex align-items-center bg-opacity-25" 
            style="cursor:pointer;">
            <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-blue text rounded-2 ms-n1">
              <i class="bi bi-camera"></i>
            </div>
            <div class="flex-fill px-3">
              Cameras
            </div>
          </div>
        </div>          
      </div>
      <div>
        <div class="menu-header">Burn List Regions
          <i *ngIf="!burnListRegionsLoading" style="cursor: pointer;" (click)="loadBurnListRegions()" class="fa fa-refresh"></i>
          <div class="spinner-border spinner-border-sm text-primary" role="status" *ngIf="burnListRegionsLoading">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="menu-item bg-emphasis bg-opacity-25">
          <div class="list-group mb-3">
            <div *ngFor="let region of burnListRegions" 
                 [routerLink]="'/fire-foresight/burn-list-overview/' + region.id" 
                 class="list-group-item d-flex align-items-center bg-opacity-25"
                 style="cursor:pointer;" 
                 (click)="toggleSidebar()">
              <div class="w-40px h-40px d-flex align-items-center justify-content-center bg-gradient-orange text rounded-2 ms-n1">
                <i class="bi bi-geo-alt"></i>
              </div>
              <div class="flex-fill px-3">
                <div class="fw-bold">{{region.name}}</div>
              </div>
            </div>
            <div *ngIf="!burnListRegionsLoading && burnListRegions.length === 0" 
                 class="list-group-item text-center text-muted">
              No regions available
            </div>
          </div>          
        </div>
      </div>
    </div>
    <!-- END Planned Burns menu -->
  </div>
  <!-- END scrollbar -->
</div>
<!-- END #sidebar -->

<!-- BEGIN mobile-sidebar-backdrop -->
<button class="app-sidebar-mobile-backdrop" data-toggle-target=".app"
  data-toggle-class="app-sidebar-mobile-toggled"></button>
<!-- END mobile-sidebar-backdrop -->